import { Check, Search, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import api from '../../../config/axios-conf';
import styles from '../../../assets/scss/pages/CreateOrder.module.scss';
import useCartStore from '../../../stores/cartStore';

// Port từ app: screens/employee/PackageSellerPickerModal.js (single-select NV bán/thẻ).
// UI/UX bám theo modal chọn NV hỗ trợ của dịch vụ/sản phẩm/combo (empModal trong CreateOrder).
// Logic giữ nguyên: chọn 1 NV → lưu sellerEmployeeId + sellerName → đóng.

const AVATAR_COLORS = ['#0098F6', '#22C55E', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#14B8A6', '#F97316'];

function getAvatarColor(name) {
    let h = 0;
    for (let i = 0; i < (name || '').length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
    return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

const normalize = (s) =>
    (s || '')
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/đ/g, 'd');

export default function PackageSellerPickerModal({ open, onClose, customerId, uid }) {
    const item = useCartStore((s) =>
        (s.packageCartByCustomer[customerId] || []).find((it) => it._uid === uid),
    );
    const updatePackageItem = useCartStore((s) => s.updatePackageItem);

    const [employees, setEmployees] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        if (!open) return;
        let alive = true;
        setSearch('');
        api.get('/employees/supportEmployeeAll')
            .then((res) => {
                if (alive) setEmployees(res?.data?.employees || []);
            })
            .catch(() => {
                if (alive) setEmployees([]);
            });
        return () => {
            alive = false;
        };
    }, [open]);

    if (!open || !item) return null;

    const handleSelect = (emp) => {
        updatePackageItem(customerId, uid, { sellerEmployeeId: emp.id, sellerName: emp.name });
        onClose();
    };

    const filtered = employees
        .filter((emp) => emp.user?.role !== 'checkin')
        .filter((emp) => (!search.trim() ? true : normalize(emp.name).includes(normalize(search))));

    return (
        <div className={styles.sideModalOverlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <div>
                        <h3 className={styles.modalTitle}>Chọn nhân viên bán gói</h3>
                        <div style={{ fontSize: 13, color: '#6B7280', marginTop: 2 }}>
                            {item.name} · ×{item.quantity}
                        </div>
                    </div>
                    <button className={styles.modalClose} onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                <div className={styles.modalSearch}>
                    <Search size={16} />
                    <input
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Tìm nhân viên..."
                        autoFocus
                    />
                </div>

                <div className={styles.modalList}>
                    {filtered.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: 24, color: '#94A3B8', fontSize: 13 }}>
                            {employees.length === 0 ? 'Không tải được danh sách NV' : 'Không tìm thấy'}
                        </div>
                    ) : (
                        filtered.map((emp) => {
                            const isSelected = item.sellerEmployeeId === emp.id;
                            return (
                                <div
                                    key={emp.id}
                                    className={`${styles.modalItem}${isSelected ? ` ${styles.modalItemActive}` : ''}`}
                                    onClick={() => handleSelect(emp)}
                                >
                                    <div
                                        className={styles.customerAvatar}
                                        style={{
                                            background: getAvatarColor(emp.name),
                                            width: 38,
                                            height: 38,
                                            fontSize: 14,
                                        }}
                                    >
                                        {(emp.name || '?')[0].toUpperCase()}
                                    </div>
                                    <div className={styles.modalItemInfo}>
                                        <div className={styles.modalItemName}>{emp.name}</div>
                                        {emp.position && (
                                            <div className={styles.modalItemPhone}>{emp.position}</div>
                                        )}
                                    </div>
                                    {isSelected && (
                                        <div className={styles.modalItemCheck}>
                                            <Check size={13} />
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
}
